import React, { useEffect, useState, useRef} from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import useRequest from "../../../../hooks/useRequest";
import Breadcrumb from "../../../Breadcrumb/Breadcrumb";
import { Input,RenderInputFields, SubmitButton, SubTab, SubInput,CKEditorInput } from "../../../Form/Form";
import { compareChanges } from "../../../../util/fn";
import { CHANGES_REQ_MESSAGE } from "../../../../util/other";
import { useSelector } from "react-redux";
import { API } from "../../../../constant/api";


const Edit = (props) => {
  const { id: recordId } = props.match.params;
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    control,
    reset,
    getValues,
    trigger,
    clearErrors
  } = useForm();
  const ckEditorRef = useRef();
  const { languages } = useSelector((state) => state.setting);
  const { response: responseData, request: requestData } = useRequest();
  const { response, request } = useRequest();
  const [ckcontent, setCkContent]           = useState()
  const [oldValues, setOldValues] = useState([]);

  useEffect(() => {
    if (recordId) {
      requestData("GET", `getting-started/${recordId}`);
      document.title = "Edit Guide Scenario 1 - Calevalab";
    }
  }, [recordId]);

  useEffect(() => {
    ckEditorRef.current = {};
    if (languages) {
      languages.forEach((lang) => {
        register(`description-${lang.code}`);
        ckEditorRef.current[lang.code] = null;
      });
    }
  }, [languages]);

  useEffect(() => {
    if (responseData) {

      const { title, langData, description } = responseData.data;

      const langDataWithoutId = langData.map(({ _id: _, ...rest }) => rest);
      const langDataShortedOld = langDataWithoutId.sort((a, b) => a.languageCode.localeCompare(b.languageCode));
      setOldValues({
        langData: langDataShortedOld,
        // title
      });
      const subData = {};
      if (langData?.length > 0) {
        langData.forEach((lang) => {
          const code = lang?.languageCode;
          subData["id-" + code] = lang?._id;
          subData["title-" + code] = lang?.title;
          subData["description-" + code] = lang?.description;
        });
        reset({ ...subData });
      }
      setValue("title", title);
      setValue("description", description);
      setCkContent(true);
    }
  }, [responseData]);

  useEffect(() => {
    if (response) {
      toast.success("Guide for Coach Scenario-1 has been updated successfully.");
      history.push("/getting-started/guide-for-coach/scenario-1");
    }
  }, [response]);

 
  const onSubmit = (data) => {

    const dataToSend = [], defaultData = {};
    let error = [];

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;
      dataToSend.push({
        languageCode: code,
        description: data["description-" + code] ?? "",
        title: data["title-" + code]?? "",
        id: data[`id-${code}`] ?? "",
      });
      if (languages[i].default) {
        defaultData.title = data["title-" + code];
        defaultData.description = data["description-" + code];
      }

      //  if (data["description-" + code].length === 0) {
      //     setError(`description-${code}`, {
      //       type: "manual",
      //     });
      //     error.push(true);
      //   }
    }

    // if(error.some(err => err === true)){
    //   return;
    // }

    const langDataWithoutId = dataToSend.map(({ id: _, ...rest }) => rest);
    const langDataShorted = langDataWithoutId.sort((a, b) => a.languageCode.localeCompare(b.languageCode));

    let newData = {
      
      langData:langDataShorted
    };

    
    if(compareChanges(oldValues,newData)){
      request("PUT", "getting-started", {...defaultData, id:recordId, langData:dataToSend});
    }
    else {
      toast.error(CHANGES_REQ_MESSAGE);
    }
  };



  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Edit Guide Scenario 1"
        links={[
          { to: "/", name: "Dashboard" },
          {
            to: { pathname: "/getting-started/guide-for-coach/scenario-1" /*backPageNum: page */ },
            name: "Back To Guide Scenario 1",
          },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">
                    Edit Guide Scenario-1
                  </h3>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row"></div>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <>
                                <SubInput
                                  key={index}
                                  index={index}
                                  errors={errors}
                                  register={register}
                                  //   required={lang.default}
                                  required={true}
                                  // InputFields={InputFields}
                                  code={lang.code}
                                  InputFields={ [
                                    [
                                      {
                                        Component: Input,
                                        label: "Title",
                                        type: "text",
                                        name: "title",
                                        registerFields: {
                                          required: true,
                                        },
                                      
                                      },
                                      
                                     
                                    ],
                                    [{
                                      Component: CKEditorInput,
                                      colClass: "col-xl-12",
                                      label: "Description",
                                      name: "description",
                                      registerFields: {
                                        required: false,
                                      },
                                      getValues,
                                      setValue,
                                      trigger,
                                      // otherRegisterFields: {
                                      //   manual: true,
                                      //   feedback: "Description is required",
                                      // },
                                      inputData: {
                                        onInstanceReady: (editor) => {
                                          ckEditorRef.current[lang.code] = editor;
                                        },
                                      },
                                      clearErrors,
                                          isEdit: true,
                                          ckcontent:ckcontent
                                    }]
                                  ]
                                
                                }
                                />
                              </>
                            ))}
                        </div>
                        <div className="row"></div>
                      </div>
                    </div>
                    <div className="row"></div>

                    

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Update"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
